<template>
   <div @click="clickEvent" class="common_box" style="padding: 0;">
        <div class="img_wrapper">
            <img style="width: 100%; object-fit: cover;" :src="imgPath" alt="">
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'HomeBottombannerFrame',
    props: {
        imgPath: {
            type: String,
            default: ''
        },
        clickEvent: {
            type: Function,
            default: () => { }
        }
    }
}
</script>

<style scoped>
.common_box {
    width: 250px;
    height: 136px;
    flex-shrink: 0;
    border-radius: 12px;
    padding: 0;
    position: relative;
}

.img_wrapper {
    overflow: hidden;
    border-radius: 12px;
    position: absolute;
    z-index: 1;
}
</style>